import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import {ElMessage} from "element-plus";
import AuthService from '@/services/AuthService';
import LoginView from '@/views/LoginView.vue';
import DashboardLayout from '@/components/layouts/DashboardLayout.vue';
import OrganizationsView from '@/views/OrganizationsView.vue';
import UsersView from '@/views/UsersView.vue';
import {useMainStore} from "@/stores/mainStore";
import ForbiddenView from "@/views/ForbiddenView.vue";
import UploadView from "@/views/UploadView.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: {
            guest: true
        }
    },
    {
        path: "/",
        redirect: "organizations",
        component: DashboardLayout,
        children: [
            {
                path: "/organizations",
                name: "organizations",
                component: OrganizationsView,
                meta: {
                    auth: true,
                    roles: ["SUPER"]
                }
            },
            {
                path: "/users",
                name: "users",
                component: UsersView,
                meta: {
                    auth: true
                }
            },
            {
                path: "/upload",
                name: "upload",
                component: UploadView,
                meta: {
                    auth: true
                }
            },
            {
                path: "/403",
                name: "403",
                component: ForbiddenView,
                meta: {
                    auth: true
                }
            }
        ]
    },]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    const token = sessionStorage.getItem("access-token");

    const store = useMainStore();

    if (to.meta.auth) {
        if (token === null) return next("/login");
        try {
            store.admin = await AuthService.auth();
            if (to.meta.roles && Array.isArray(to.meta.roles) && !to.meta.roles.includes(store.admin.role)) {
                return next("/403");
            }
        } catch (error) {
            sessionStorage.removeItem("access-token");
            ElMessage.warning({ message: "La sessione è scaduta, è necessario accedere nuovamente" });
            return next("/login");
        }
    } else if (to.meta.guest) {
        if (token !== null) {
            try {
                store.admin = await AuthService.auth();
                return next("/");
            } catch (error) {
                sessionStorage.removeItem("access-token");
            }
        }
    }

    return next();
});

export default router;